import {
    createBrowserRouter,
} from 'react-router-dom';

/*** 引入路由界面 ***/
import Error404 from './Error404.js';
import App from '../App.js';
import Admin from '../Admin.js';
/*** 引入路由界面 ***/

const BasicRouter = createBrowserRouter([
    {
        path: '/',
        element: <App m={1} />,
        errorElement: <Error404 />,
    }, {
        path: '/admin',
        element: <Admin m={11} />,
        errorElement: <Error404 />,
    }, {
        path: '/admin/quota/tokens',
        element: <Admin m={11} />,
        errorElement: <Error404 />,
    }, {
        path: '/admin/quota/images',
        element: <Admin m={12} />,
        errorElement: <Error404 />,
    }, {
        path: '/admin/command/publics',
        element: <Admin m={21} />,
        errorElement: <Error404 />,
    }, {
        path: '/admin/command/keywords',
        element: <Admin m={22} />,
        errorElement: <Error404 />,
    }, {
        path: '/admin/report/log/ttcd',
        element: <Admin m={31} />,
        errorElement: <Error404 />,
    }, {
        path: '/admin/report/log/trcd',
        element: <Admin m={32} />,
        errorElement: <Error404 />,
    }, {
        path: '/admin/report/log/dmc',
        element: <Admin m={33} />,
        errorElement: <Error404 />,
    }, {
        path: '/admin/report/quota/rqtc',
        element: <Admin m={34} />,
        errorElement: <Error404 />,
    }, {
        path: '/admin/log/operations',
        element: <Admin m={41} />,
        errorElement: <Error404 />,
    }, {
        path: '/admin/log/apis',
        element: <Admin m={42} />,
        errorElement: <Error404 />,
    }, {
        path: '/admin/log/models',
        element: <Admin m={43} />,
        errorElement: <Error404 />,
    },
]);

export default BasicRouter